import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface INotification {
  id: string;
  message: string;
  isUnRead: boolean;
}

export interface NotificationState {
  notifications: INotification[];
}

const initialState: NotificationState = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    // addNotification: (state, action: PayloadAction<INotification>) => {
    //   const existingIndex = state.notifications.findIndex(
    //     (n) => n.id === action.payload.id
    //   );
    //   // only add if the notification doesn't exist
    //   if (existingIndex === -1) {
    //     state.notifications.push(action.payload);
    //   } else {
    //     throw new Error(
    //       `Notification with ID ${action.payload.id} already exist`
    //     );
    //   }
    // },
    addNotification: (state, action) => {
      if (!state.notifications.some((n) => n.id === action.payload.id)) {
        state.notifications.push(action.payload);
      }
    },

    markNotificationAsRead: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex(
        (notification) => notification.id === action.payload
      );
      if (index !== -1) {
        state.notifications[index].isUnRead = false;
      }
    },

    markAllNotificationAsRead: (state) => {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        isUnRead: false,
      }));
    },

    markAllNotificationAsUnRead: (state) => {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        isUnRead: true,
      }));
    },

    deleteNotification: (state, action: PayloadAction<any>) => {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
    },

    clearAllNotification: (state) => {
      state.notifications = [];
    },
  },

  extraReducers: (builder) => {},
});

export const {
  addNotification,
  markNotificationAsRead,
  markAllNotificationAsRead,
  markAllNotificationAsUnRead,
  deleteNotification,
  clearAllNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
